import React, { useEffect, useState, useMemo } from "react";
import { Formik, Form, Field } from "formik";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { Container, Input, Table } from 'reactstrap';
import { useNavigate } from "react-router-dom";
import "../../share/form.css";
import { BsPlusCircle } from "react-icons/bs";
import "../../share/TableLanding.css";
// import CreateTableComponent from "../../share/CreateTableComponent";
import CreateTableHaveFooterComponent from "../../share/CreateTableHaveFooterComponent";
import { FiEdit } from "react-icons/fi";
import Select from "react-select";

import { NumberWithCommas } from "../../share/NumberWithCommas";
import { NumericFormat } from 'react-number-format';
import { CustomInputNumeric } from "../../share/CustomInputNumeric";
import Modal from "react-modal"
// import { getCustomStyles } from "../../share/ModalStyle";
import { CgClose } from "react-icons/cg";
import { FormikSelect } from "../../share/FormikSelect";
import { GetVMdDept } from "../../share/api/MasterDataApi";


export function BudgetYearLimitDetailComponent() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("userData"));
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [deptsData, setDeptsData] = useState([]);
  const [selectedBudgetYear, setSelectedBudgetYear] = useState(null); // value: {value, label}

  console.log("deptsData", deptsData);
  const [loading, setLoading] = useState(false);
  const [provincialAllocations, setProvincialAllocations] = useState([]);
  console.log("provincialAllocations", provincialAllocations);
  // const [loading, setLoading] = useState(false);
  // const [FoundValue, setFoundValue] = useState(false);
  const [Condition, setCondition] = useState([]);
  // const myCustomStyles = getCustomStyles()
  // const [Condition1, setCondition1] = useState([]);
  // const [Condition2, setCondition2] = useState([]);
  const modalToggle = () => {
    setModal(!modal)

  };

  const getCustomStyles = (isSupport10 = false) => ({
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: isSupport10 ? '85vw' : '75vw',
      width: '100%',
      maxHeight: isSupport10 ? '90vh' : '50vh',
      // overflow: 'hidden',
      overflow: isSupport10 ? 'auto' : 'hidden',
      padding: '2rem',
      borderRadius: '16px',
      boxShadow: '0 5px 20px rgba(0,0,0,0.2)',
      minHeight: isSupport10 ? '90vh' : '40vh',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1000
    }
  });


  const conditionOptions = Condition?.map((item) => ({
    value: item.supportConditionId,
    label: item.announceDetail,
  }));

  const budgetYearOptions = useMemo(() => {
    const years = [...new Set(data?.map((item) => item.budgetYear))];
    const yearOptions = years.sort().map((year) => ({ value: year, label: year }));
    return [{ value: "", label: "ทั้งหมด" }, ...yearOptions];
  }, [data]);

  const filteredData = useMemo(() => {
    if (!selectedBudgetYear || selectedBudgetYear.value === "") return data;
    return data?.filter(item => item.budgetYear === selectedBudgetYear.value);
  }, [data, selectedBudgetYear]);

  useEffect(() => {
    getcondition();
    getyearbudgetlist();
    GetVMdDept({ setDeptsData, setLoading }) //ดึงmaster data หน่วยงานกรมพัฒฯ

  }, []);

  useEffect(() => {
    if (budgetYearOptions.length > 0 && !selectedBudgetYear) {
      setSelectedBudgetYear({ value: "", label: "ทั้งหมด" });
    }
  }, [budgetYearOptions]);

  async function getyearbudgetlist() {
    // setLoading(true);
    try {
      const responseCondition = await fetch("/api/Support/getyearbudgetlist");
      const data = await responseCondition.json();
      if (data !== null) {
        // setFoundValue(true)
      }
      setData(data.dataenum);
    } catch (e) {
      console.log("err => " + e);
    } finally {
      // setLoading(false);
    }
  }
  async function getcondition() {
    // setLoading(true);
    try {
      const responseCondition = await fetch("/api/Borrow/getCondition");
      const data = await responseCondition.json();
      if (data !== null) {
        // setFoundValue(true)
      }
      setCondition(data.dataenum);
    } catch (e) {
      console.log("err => " + e);
    } finally {
      // setLoading(false);
    }
  }


  const formInitialValues = {
    budgetYear: "",
    amountlimit: "",
    Updateby: user.fullName,
    Createby: user.fullName,
    update: "0",
    budgetId: "",
    supportConditionId: "",
  };

  const validateSchema = Yup.object().shape({});

  const onSubmit = async (values, action) => {
    // if (values.supportConditionId === 10) {
    //   const total = provincialAllocations.reduce((sum, p) => sum + parseFloat(p.amount || "0"), 0);
    //   const limit = parseFloat(values.amountlimit || "0");

    //   if (total > limit) {
    //     Swal.fire({
    //       icon: "warning",
    //       title: "วงเงินรวมเกินกว่าวงเงินช่วยเหลือที่กำหนด",
    //       text: `กรุณาลดวงเงินรวมให้ไม่เกิน ${NumberWithCommas(limit.toFixed(2))} บาท`,
    //       confirmButtonColor: "#d33",
    //       confirmButtonText: "ตกลง",
    //     });
    //     return; // ยกเลิก submit
    //   }
    // }
    // console.log("Values", values);

    let postData = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      if (key == "provincialAllocations") {
        return;
      }
      postData.append(key, value);
    });

    postData.append("provincialAllocations", JSON.stringify(provincialAllocations));

    try {
      let res = await fetch("api/Support/savesupportbudgetyear", {
        method: "POST",
        // headers: { "Content-type": "application/json" },
        body: postData,
      });
      // console.log("values5", values);
      let resJson = await res.json();

      if (resJson.status === 1) {
        Swal.fire({
          icon: "success",
          title: "บันทึกข้อมูลสำเร็จ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        }).then((result) => {
          modalToggle();
          action.resetForm();
          window.location.reload()
        });
      }
      else {
        Swal.fire({
          icon: "warning",
          title: "บันทึกข้อมูลไม่สำเร็จ",
          confirmButtonColor: "#0A66C2",
          confirmButtonText: "ตกลง",
        })
      }
    } catch (e) {
      console.log(e);
    }

  };


  console.log("deptdata", deptsData);
  useEffect(() => {
    const initial = deptsData?.filter(item => item.value != "01").map((dept) => ({
      deptId: dept.value,
      deptName: dept.label,
      amount: "",
      personTotal: "",
    }));
    setProvincialAllocations(initial);
  }, [deptsData])

  // const totalAllocation = provincialAllocations?.reduce((sum, p) => {
  //   const amount = parseFloat(p.amount || "0");
  //   return sum + (isNaN(amount) ? 0 : amount);
  // }, 0);

  return (
    <Container>
      <Formik
        initialValues={formInitialValues}
        validationSchema={validateSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({
          values,
          handleChange,
          handleBlur,
          setFieldValue,
          setValues,
          resetForm,
          errors,
          touched,
        }) => {

          console.log("values", values);

          const closemodalToggle = () => {
            setModal(!modal)
            resetForm();
          };


          async function onEdit(id) {
            const found = data.find(({ budgetAmountId }) => budgetAmountId == id)
            console.log("found",found)
            console.log("found", found);
            // const matchedCondition = conditionOptions.find(opt => opt.value === found.supportTypeId);
            setFieldValue("budgetYear", found.budgetYear);
            setFieldValue("amountlimit", found.amount);
            // setFieldValue("personTotal", found.personTotal);
            setFieldValue("budgetId", id);
            setFieldValue("supportConditionId", Number(found.supportTypeId));
            setProvincialAllocations(found?.provincialAllocations ?? []);
            setFieldValue("provincialAllocations", found?.provincialAllocations ?? []);
            setFieldValue("update", "1");
            modalToggle();
          }

          const COLUMNS = [
            {
              Header: "ลำดับ",
              accessor: (_row, i) => i + 1,
              enableRowSpan: true,
            },
            {
              Header: "ประจำปีงบประมาณ w.ศ ",
              accessor: "budgetYear",
              // Cell: ({ value }) => {
              //   return <>{NumberWithCommas(value)} %</>;
              // },
            },
            {
              Header: "หัวข้อประกาศ",
              accessor: "supportAnnouceDetail",
              Cell: ({ value }) => {
                return <div className="d-flex justify-content-start">{value}</div>;
              },
            },
            {
              Header: "วงเงินช่วยเหลือหรืออุดหนุน",
              accessor: "amount",
              Cell: ({ row, value }) => {
                return (
                  <div className="d-flex justify-content-end">
                    {NumberWithCommas(row.original.amount)}
                    <FiEdit
                      className="mx-3 style-icon"
                      onClick={() =>
                        onEdit(row.original.budgetAmountId)
                      }
                    />
                  </div>
                );
              },
              Footer: ({ data }) => {
                // console.log("data", data);
                const sum = useMemo(
                  () =>
                    data.reduce((acc, row) => {
                      return Number(acc) + Number(row?.amount ?? 0);
                    }, 0),
                  [data]
                );
                return (
                  <div className="d-flex">
                    <div className="text-center">รวม</div>
                    <div className="text-right w-100">{NumberWithCommas(sum)}</div>
                  </div>
                )
              }
            },
          ]

          const FormButton = () => {
            if (user.roldId === "4") {
              return (
                <button
                  onClick={() => modalToggle()}
                  type="button"
                  className="btn-green p-2"
                >
                  <BsPlusCircle className="mx-1" />
                  เพิ่มข้อมูล
                </button>
              )
            } else {
              <></>
            }
          }

          // const handleAllocationChange = (index, newAmount) => {
          //   setProvincialAllocations((prev) =>
          //     prev.map((row, i) =>
          //       i === index ? { ...row, amount: newAmount } : row
          //     )
          //   );
          // };
          const handleAllocationChange = (index, key, newValue) => {
            setProvincialAllocations((prev) =>
              prev.map((row, i) =>
                i === index ? { ...row, [key]: newValue } : row
              )
            );
          };
          const isSupport10 = values.supportConditionId === 10;
          const myCustomStyles = getCustomStyles(isSupport10);
          return (
            <>

              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <label className="me-3">ปีงบประมาณ </label>
                  <div className="">
                    <Select
                      options={budgetYearOptions}
                      value={selectedBudgetYear}
                      onChange={(selectedOption) => setSelectedBudgetYear(selectedOption)}
                      isClearable
                      placeholder="เลือกปีงบประมาณ"
                      classNamePrefix="react-select"
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          borderRadius: '50px', // 🟢 เปลี่ยนตรงนี้
                          borderColor: state.isFocused ? '#2684FF' : provided.borderColor,
                          boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : provided.boxShadow,
                          '&:hover': {
                            borderColor: '#2684FF',
                          },
                        }),
                      }}
                    />
                  </div>
                </div>
                <FormButton />
              </div>


              <CreateTableHaveFooterComponent
                column={COLUMNS}
                dataInput={filteredData}
                showEntrie={false}
                showPage={true}
              // FormInput={<></>}
              />
              <Modal
                isOpen={modal}
                onRequestClose={modalToggle}
                style={myCustomStyles}


              >
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="w-100" style={{ color: "#0E527E", maxWidth: "960px", width: "100%" }}>เพิ่มข้อมูลประจำปีงบประมาณ</h3>
                  <CgClose onClick={modalToggle} className="style-iconmodal" />
                </div>

                <hr />

                <div className="px-4 mt-4">
                  {/* 🔹 แถวที่ 1: หัวข้อประกาศ */}
                  <div className="row mb-4">
                    <div className="col-12">
                      <label className="form-label">หัวข้อประกาศ</label>
                      <Field name="supportConditionId">
                        {({ field, form: { setFieldValue, values, errors, touched } }) => (
                          <Select
                            name={field.name}
                            onBlur={field.onBlur}
                            onChange={({ value }) => setFieldValue(field.name, value)}
                            options={conditionOptions}
                            placeholder={<div className="input-color text-center">กรุณาเลือก</div>}
                            value={(conditionOptions ? conditionOptions.find(option => option.value == field.value) : '')}
                            className={`text-center input-color`}
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                borderRadius: "20px",
                                borderColor: errors[field.name] && touched[field.name] ? "#ff0000" : "#ced4da",
                                color: "#0A66C2"
                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: '#0A66C2',
                              }),
                            }}
                          />
                        )}
                      </Field>
                      {/* <Field
                        name="supportConditionId"
                        component={FormikSelect}
                        options={conditionOptions}
                        placeholder={<div className="input-color text-center">กรุณาเลือก</div>}
                      /> */}
                    </div>
                  </div>

                  {/* 🔹 แถวที่ 2: ปีงบประมาณ และ วงเงิน */}
                  <div className="row g-3">
                    {/* ปีงบประมาณ */}
                    <div className="col-md-6">
                      <label className="form-label">ปีงบประมาณ</label>
                      <Field name="budgetYear">
                        {({ field }) => (
                          <Input
                            type="text"
                            {...field}
                            className="form-control rounded-pill text-center input-color"
                            placeholder="เช่น 2567"
                          />
                        )}
                      </Field>
                      {/* <small className="text-danger">กรุณาระบุเป็น พ.ศ.</small> */}
                    </div>

                    {/* วงเงิน */}
                    <div className="col-md-6">
                      <label className="form-label">วงเงินช่วยเหลือหรืออุดหนุน</label>
                      <Field name="amountlimit">
                        {({ field, form: { setFieldValue, values } }) => (
                          <NumericFormat
                            {...field}
                            thousandSeparator=","
                            decimalScale={2}
                            allowNegative={false}
                            isNumericString={true}
                            value={values.amountlimit}
                            onValueChange={(val) =>
                              setFieldValue(field.name, val.value)
                            }
                            customInput={CustomInputNumeric}
                            className="form-control rounded-pill text-end"
                          />
                        )}
                      </Field>
                    </div>
                  </div>
                </div>



                {values.supportConditionId === 10 && provincialAllocations.length > 0 && (
                  <div className="mt-4">

                    {/* ✅ แยก Scroll สำหรับตาราง */}
                    <div
                      style={{ maxHeight: '60vh', overflowY: 'auto' }}
                      className="table-responsive border rounded"
                    >
                      <Table bordered className="table-modern align-middle">
                        <thead
                          className="sticky-top"
                        // style={{ top: 0, zIndex: 1 }}
                        >
                          <tr className="text-center">
                            <th style={{ width: '60px' }}>ลำดับ</th>
                            <th>จังหวัด</th>
                            <th style={{ width: '200px' }}>วงเงินที่จัดสรร (บาท)</th>
                            <th style={{ width: '200px' }}>จำนวนคน</th>
                          </tr>
                        </thead>
                        <tbody>
                          {provincialAllocations.map((prov, index) => (
                            <tr key={prov.deptId}>
                              <td className="text-center">{index + 1}</td>
                              <td>{prov.deptName}</td>
                              <td>
                                <Field name={`provincialAllocations[${index}].amount`}>
                                  {({ field, form: { setFieldValue } }) => (
                                    <NumericFormat
                                      {...field}
                                      // value={prov.amount}
                                      thousandSeparator=","
                                      decimalScale={2}
                                      allowNegative={false}
                                      isNumericString={true}
                                      onValueChange={(val) => {
                                        setFieldValue(field.name, val.value)
                                        // handleAllocationChange(index, val.value)
                                        handleAllocationChange(index, "amount", val.value); // ✅ sync state สำหรับ render
                                      }}
                                      customInput={CustomInputNumeric}
                                      className="form-control rounded-pill text-end"
                                    />
                                  )}
                                </Field>
                              </td>
                              <td>
                                <Field name={`provincialAllocations[${index}].personTotal`}>
                                  {({ field, form: { setFieldValue } }) => (
                                    <NumericFormat
                                      {...field}
                                      // value={prov.amount}
                                      thousandSeparator=","
                                      decimalScale={2}
                                      allowNegative={false}
                                      isNumericString={true}
                                      onValueChange={(val) => {
                                        setFieldValue(field.name, val.value)
                                        // handleAllocationChange(index, val.value)
                                        handleAllocationChange(index, "personTotal", val.value);
                                      }}
                                      customInput={CustomInputNumeric}
                                      className="form-control rounded-pill text-end"
                                    />
                                  )}
                                </Field>
                              </td>
                              {/* <td>
                                <NumericFormat
                                  // {...field}
                                  thousandSeparator=","
                                  decimalScale={2}
                                  allowNegative={false}
                                  isNumericString={true}
                                  value={prov.amount}
                                  onValueChange={(val) =>
                                    handleAllocationChange(index, val.value)
                                  }
                                  customInput={CustomInputNumeric}
                                  className="form-control rounded-pill text-end"
                                />
                               
                              </td> */}
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr className="fw-bold">
                            <td colSpan={2} className="text-end">รวม</td>
                            <td className="text-end">
                              {NumberWithCommas(
                                provincialAllocations.reduce((sum, p) => sum + parseFloat(p.amount || "0"), 0).toFixed(2)
                              )}
                            </td>
                            <td className="text-end">
                              {NumberWithCommas(
                                provincialAllocations.reduce((sum, p) => sum + parseFloat(p.personTotal || "0"), 0)
                              )}
                            </td>
                          </tr>
                        </tfoot>
                      </Table>
                    </div>
                  </div>
                )}


                <div className="d-flex justify-content-evenly text-center w-100">
                  <Form className="d-flex justify-content-evenly text-center w-100">
                    <button className="btn-green rounded-pill w-25 my-5" type="submit">
                      บันทึก
                    </button>

                    <button className="btn-red rounded-pill w-25 my-5"
                      type="button" onClick={() =>
                        closemodalToggle()

                      }>
                      ยกเลิก
                    </button>
                  </Form>
                </div>

              </Modal>
            </>
          );
        }}
      </Formik>
      <div class="boxes-tn">
        <div></div> <div></div>
        <div></div> <div></div>
        <div></div> <div></div>
        <div></div> <div></div>
        <div></div>
      </div>
    </Container>
  );
}